import { createSelector } from "@ngrx/store";
import { EditProgramStoreSelectors } from "../components/edit-program/store";
import { ProgramListStoreSelectors } from "../components/program-list/store";

export const selectIsLoading = createSelector(
  EditProgramStoreSelectors.selectIsLoading,
  ProgramListStoreSelectors.selectIsLoading,
  (...isLoadings) => isLoadings.find((isLoading) => isLoading)
);
